module.exports = "/_next/static/images/tails3-9b51de47f523e2cbdc64176a086ab713.png";